var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "custom-tags-ai-modal",
      attrs: {
        visible: _vm.visible,
        title: _vm.$t.__("ai.CustomTagsAIModal.title_dialog"),
        closeOnClickOverlay: false
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClose
      }
    },
    [
      _c(
        "template",
        { slot: "default" },
        [
          _c(
            "CompassFormItem",
            {
              staticClass: "custom-tags-ai-modal__name",
              attrs: {
                label: _vm.$t.__("ai.CustomTagsAIModal.form_item_name_tags_ai"),
                error: _vm.errorLabelCustomTagAIName,
                required: "",
                requiredLabel: _vm.$t.__("common.labels.required")
              }
            },
            [
              _c("CompassInput", {
                ref: "nameInput",
                attrs: {
                  error: !!_vm.errorLabelCustomTagAIName,
                  placeholder: _vm.$t.__(
                    "ai.CustomTagsAIModal.placeholder_name_tags_ai"
                  )
                },
                model: {
                  value: _vm.customTagAIName,
                  callback: function($$v) {
                    _vm.customTagAIName = $$v
                  },
                  expression: "customTagAIName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("RichText", {
            attrs: {
              formitem: _vm.formItemRichText,
              placeholder: _vm.$t.__(
                "ai.CustomTagsAIModal.placeholder_prompt_tags_ai"
              ),
              options: _vm.optionsRichText
            },
            model: {
              value: _vm.customTagAIPrompt,
              callback: function($$v) {
                _vm.customTagAIPrompt = $$v
              },
              expression: "customTagAIPrompt"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "custom-tags-ai-modal__footer" },
          [
            _c("CompassButton", {
              attrs: {
                type: "secondary",
                label: _vm.$t.__("common.actions.cancel")
              },
              on: { click: _vm.handleClose }
            }),
            _vm._v(" "),
            _c("ButtonAI", {
              attrs: {
                label: _vm.$t.__("common.actions.validate"),
                size: "medium"
              },
              on: { click: _vm.handleValidate }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }